import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DEFAULT_REGISTRATION_EVENT_KEY } from './config/event-registration-config';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Team from './components/Team';
import Events from './components/Events';
import GetInvolved from './components/GetInvolved';
import Contact from './components/Contact';
import EventRegistration from './components/EventRegistration';
import Feedback from './components/Feedback';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/events" element={<Events />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/register/:eventId" element={<EventRegistration />} />
            <Route
              path="/eventregistration"
              element={<Navigate to={`/register/${DEFAULT_REGISTRATION_EVENT_KEY}`} replace />}
            />
            <Route path="/feedback" element={<Feedback />} />
            {/* Catch-all route for unmatched paths */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App; 